/**
 * React Query hooks for Outstanding
 */

import { useQuery } from "@tanstack/react-query";
import { outstandingService } from "../services/outstanding.service";

export const useOutstanding = (params?: { firmId?: number }) => {
  return useQuery({
    queryKey: ["outstanding", params],
    queryFn: () => outstandingService.getOutstanding(params),
  });
};

export const useOutstandingSummary = (params?: { startDate?: string; endDate?: string }) => {
  return useQuery({
    queryKey: ["outstanding", "summary", params],
    queryFn: () => outstandingService.getOutstandingSummary(params),
    staleTime: 5 * 60 * 1000,
  });
};

export const useOutstandingByCustomer = (customerId: string) => {
  return useQuery({
    queryKey: ["outstanding", "customer", customerId],
    queryFn: () => outstandingService.getOutstandingByCustomer(customerId),
    enabled: !!customerId,
  });
};

export const useAgingAnalysis = () => {
  return useQuery({
    queryKey: ["outstanding", "aging"],
    queryFn: () => outstandingService.getAgingAnalysis(),
    staleTime: 5 * 60 * 1000,
  });
};

export const useOutstandingBillDetails = (params: {
  firmId: number;
  partyCode: string;
  mode?: number;
  enabled?: boolean;
}) => {
  return useQuery({
    queryKey: ["outstanding", "billDetails", params.firmId, params.partyCode, params.mode],
    queryFn: () => outstandingService.getOutstandingBillDetails({
      firmId: params.firmId,
      partyCode: params.partyCode,
      mode: params.mode,
    }),
    enabled: params.enabled !== false && !!params.partyCode,
  });
};

